import React from 'react'

export const GridIcon = React.forwardRef<SVGSVGElement>((props, ref): React.ReactElement => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>
      <path
        d="M5.3 11H2.7C1.76112 11 1 11.7611 1 12.7V15.3C1 16.2389 1.76112 17 2.7 17H5.3C6.23888 17 7 16.2389 7 15.3V12.7C7 11.7611 6.23888 11 5.3 11Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.3 1H2.7C1.76112 1 1 1.76112 1 2.7V5.3C1 6.23888 1.76112 7 2.7 7H5.3C6.23888 7 7 6.23888 7 5.3V2.7C7 1.76112 6.23888 1 5.3 1Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3 11H12.7C11.7611 11 11 11.7611 11 12.7V15.3C11 16.2389 11.7611 17 12.7 17H15.3C16.2389 17 17 16.2389 17 15.3V12.7C17 11.7611 16.2389 11 15.3 11Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3 1H12.7C11.7611 1 11 1.76112 11 2.7V5.3C11 6.23888 11.7611 7 12.7 7H15.3C16.2389 7 17 6.23888 17 5.3V2.7C17 1.76112 16.2389 1 15.3 1Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default GridIcon
